"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generator_crokinole = void 0;
var crokinoleBackground_sidecar_1 = require("@crokinole/background/crokinoleBackground-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var crokinolePucks_sidecar_1 = require("proto/crokinole/entities/crokinolePucks-sidecar");
var crokinoleDefs_sidecar_1 = require("proto/crokinole/main/crokinoleDefs-sidecar");
var crokinoleGameState_1 = require("proto/crokinole/main/crokinoleGameState");
var crokinoleGameState_sidecar_1 = require("proto/crokinole/main/crokinoleGameState-sidecar");
var crokinoleUi_menu_main_sidecar_1 = require("proto/crokinole/ui-menus/crokinoleUi_menu_main-sidecar");
var crokinoleUi_turnInfo_sidecar_1 = require("proto/crokinole/ui/crokinoleUi_turnInfo-sidecar");
var namespace = 'generator_crokinole';
function generator_crokinole() {
    var _loop_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                console.log(namespace, 'start');
                crokinoleUi_menu_main_sidecar_1.crokinoleUi_menu_main.setOpen('in-game');
                // if (!voyageWebsockets.getIsSingleplayer()) {
                //   while (websockets.isStillConnecting()) {
                //     yield 0
                //   }
                // }
                // voyageGameMode_scenario_new.reset()
                // // Should be loading from other command
                // while (!voyageShipSaver.getIsLoaded()) {
                //   yield 0
                // }
                // voyageGameMode_game_processShipFile.processShipFile(false)
                // voyageMessageRequestGamestate.sendMessageRequest({})
                voyageCamera_sidecar_1.voyageCamera.centerOn(0, 0);
                crokinoleGameState_sidecar_1.crokinoleGameState.reset();
                _loop_1 = function () {
                    var scoreString, players, i, currentState, currentPlayer, currentPuck, numOpponents, updateTargetMode, validShot, hitOpponentCount;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, 0];
                            case 1:
                                _b.sent();
                                crokinoleBackground_sidecar_1.crokinoleBackground.setIsMoving(false);
                                scoreString = '';
                                players = crokinoleGameState_sidecar_1.crokinoleGameState.get().players;
                                for (i = 0; i < players.length; i++) {
                                    // scoreString +=
                                    //   '' + players[i].name + ' ' + '[' + players[i].numTokensLeft + '] '
                                    scoreString += '' + players[i].name + ' '; //+ '[' + players[i].numTokensLeft + '] '
                                    scoreString +=
                                        '' + crokinoleGameState_sidecar_1.crokinoleGameState.calcScoreForPlayer(players[i]).total;
                                    if (i < players.length - 1) {
                                        scoreString += ' - ';
                                    }
                                }
                                // console.log('Score: ' + scoreString)
                                crokinoleUi_turnInfo_sidecar_1.crokinoleUi_turnInfo.setText(scoreString);
                                currentState = crokinoleGameState_sidecar_1.crokinoleGameState.get().state;
                                currentPlayer = crokinoleGameState_sidecar_1.crokinoleGameState.getCurrentPlayer();
                                currentPuck = crokinoleGameState_sidecar_1.crokinoleGameState.get().currentPuck;
                                // console.log('currentState', currentState)
                                if (currentState === crokinoleGameState_1.CrokinoleGameStates.gameStart) {
                                    crokinoleGameState_sidecar_1.crokinoleGameState.reset();
                                    crokinolePucks_sidecar_1.crokinolePucks.killAll();
                                    if (crokinoleDefs_sidecar_1.crokinoleDefs.debugPucks) {
                                        crokinolePucks_sidecar_1.crokinolePucks.create(0, 1, crokinoleGameState_sidecar_1.crokinoleGameState.get().players[0]);
                                        crokinolePucks_sidecar_1.crokinolePucks.create(1, 2, crokinoleGameState_sidecar_1.crokinoleGameState.get().players[1]);
                                        crokinolePucks_sidecar_1.crokinolePucks.create(-1, 2, crokinoleGameState_sidecar_1.crokinoleGameState.get().players[1]);
                                    }
                                    // const puck1 = createPuck(0.0, 1.0)
                                    // const puck2 = createPuck(1.0, 1.0)
                                    crokinoleGameState_sidecar_1.crokinoleGameState.get().state = crokinoleGameState_1.CrokinoleGameStates.place;
                                    return [2 /*return*/, "continue"];
                                }
                                numOpponents = crokinolePucks_sidecar_1.crokinolePucks.countNumOpponentScoringPucks(crokinoleGameState_sidecar_1.crokinoleGameState.getCurrentPlayer());
                                updateTargetMode = function () {
                                    if (numOpponents > 0) {
                                        crokinoleGameState_sidecar_1.crokinoleGameState.get().shotMode = crokinoleGameState_1.CrokinoleShotMode.hitOpponent;
                                        crokinoleUi_turnInfo_sidecar_1.crokinoleUi_turnInfo.setText('Hit opponent!');
                                        // crokinoleGameState.get().hitOpponent = false
                                    }
                                    else {
                                        crokinoleGameState_sidecar_1.crokinoleGameState.get().shotMode = crokinoleGameState_1.CrokinoleShotMode.getInCenter;
                                        crokinoleUi_turnInfo_sidecar_1.crokinoleUi_turnInfo.setText('Get in the center ring!');
                                    }
                                };
                                if (currentState === crokinoleGameState_1.CrokinoleGameStates.place) {
                                    if (currentPlayer.numTokensLeft > 0) {
                                        updateTargetMode();
                                    }
                                    return [2 /*return*/, "continue"];
                                }
                                if (currentState === crokinoleGameState_1.CrokinoleGameStates.flick) {
                                    updateTargetMode();
                                    crokinolePucks_sidecar_1.crokinolePucks.clearMovementFlags();
                                    crokinoleGameState_sidecar_1.crokinoleGameState.get().lastPuckInHole = false;
                                    return [2 /*return*/, "continue"];
                                }
                                if (currentState === crokinoleGameState_1.CrokinoleGameStates.wait) {
                                    // TODO: do this on physics tick
                                    crokinolePucks_sidecar_1.crokinolePucks.checkAllForMovement();
                                    // Check for all-still
                                    if (crokinoleGameState_sidecar_1.crokinoleGameState.get().isAllStill) {
                                        validShot = true;
                                        if (crokinoleGameState_sidecar_1.crokinoleGameState.get().shotMode === crokinoleGameState_1.CrokinoleShotMode.getInCenter) {
                                            if (currentPuck &&
                                                // !crokinoleGameState.get().lastPuckInHole &&
                                                !crokinolePucks_sidecar_1.crokinolePucks.calcIsInCenter(currentPuck)) {
                                                // Not in center!
                                                // remove all pieces that moved
                                                validShot = false;
                                            }
                                        }
                                        if (crokinoleGameState_sidecar_1.crokinoleGameState.get().shotMode === crokinoleGameState_1.CrokinoleShotMode.hitOpponent) {
                                            hitOpponentCount = crokinolePucks_sidecar_1.crokinolePucks.countNumOpponentHitPucks(currentPlayer);
                                            if (hitOpponentCount <= 0) {
                                                // No opponent hit!
                                                // remove all pieces that moved
                                                validShot = false;
                                            }
                                        }
                                        if (!validShot) {
                                            if (currentPuck) {
                                                crokinolePucks_sidecar_1.crokinolePucks.flingPieceToGutter(currentPuck);
                                            }
                                            crokinolePucks_sidecar_1.crokinolePucks.removeAllPiecesThatMovedOrWereHit(currentPlayer);
                                        }
                                        crokinolePucks_sidecar_1.crokinolePucks.removeAndScorePiecesInHole(currentPlayer, validShot);
                                        crokinolePucks_sidecar_1.crokinolePucks.removeAll0ScoringPucks();
                                        crokinoleGameState_sidecar_1.crokinoleGameState.advancePlayer();
                                        // crokinoleGameState.advanceState()
                                    }
                                    return [2 /*return*/, "continue"];
                                }
                                return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3:
                console.log(namespace, 'end');
                // voyageGameManager.goGame()
                return [2 /*return*/, 0];
        }
    });
}
exports.generator_crokinole = generator_crokinole;
